export const productsData = [
  {
    id: 1,
    sku: 18644119330491312,
    title: "Sphynx Tie Dye Grey T-Shirt",
    quantity: 1,
    description: "Sphynx Tie Dye Grey",
    availableSizes: ["X", "L", "XL", "XXL"],
    price: 10,
    isFreeShipping: true,
  },

  {
    id: 2,
    sku: 11854078013954528,
    title: "Danger Knife Grey T-Shirt",
    quantity: 1,
    description: "Danger Knife Grey",
    availableSizes: ["X", "M", "L"],
    price: 14.9,
    isFreeShipping: true,
  },

  {
    id: 3,
    sku: 876661122392077,
    title: "White DGK Script Tee",
    quantity: 1,
    description: "White DGK Script",
    availableSizes: ["X", "M", "L"],
    price: 14.9,
    isFreeShipping: true,
  },

  {
    id: 4,
    sku: 9197907543445677,
    title: "Born On The Streets  T-Shirt",
    quantity: 1,
    description: "Born On The Streets",
    availableSizes: ["XL"],
    price: 25.9,
    isFreeShipping: false,
  },

  {
    id: 5,
    sku: 10547961582846888,
    title: "Tso 3D Short Sleeve T-Shirt A",
    quantity: 1,
    description: "Tso 3D Short Sleeve",
    availableSizes: ["X", "L", "XL"],
    price: 10.9,
    isFreeShipping: false,
  },

  {
    id: 6,
    sku: 6090484789343891,
    title: "Man Tie Dye Cinza Grey T-Shirt",
    quantity: 1,
    description: "Man Tie Dye Cinza Grey",
    availableSizes: ["XL", "XXL"],
    price: 49.9,
    isFreeShipping: false,
  },

  {
    id: 7,
    sku: 18532669286405342,
    title: "Crazy Monkey Black T-Shirt",
    quantity: 1,
    description: "1977 Infantil",
    availableSizes: ["S"],
    style: "Preto com listras brancas",
    price: 22.5,
    isFreeShipping: true,
  },

  {
    id: 8,
    sku: 5619496040738316,
    title: "Tso 3D Black T-Shirt",
    quantity: 1,
    description: "",
    availableSizes: ["XL"],
    style: "Azul escuro",
    price: 18.7,
    isFreeShipping: false,
  },
  {
    id: 9,
    sku: 11600983276356165,
    title: "Crazy Monkey Grey",
    quantity: 1,
    description: "",
    availableSizes: ["L", "XL"],
    price: 134.9,
    isFreeShipping: true,
  },
];
